class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        this.isFullWidth = this.item.is('.layout-4');

        this.onVariantInit();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantInit(){
        this.updateOptions();
        this.updateMasterId();
        // Initial product HTML is already server-rendered.
        // Avoid replacing it with AJAX during first paint because that can
        // change MainContent geometry and create CLS.
        this.updateMedia(1500);
        // this.updateURL();
        this.renderProductInfo();
        if (!this.currentVariant) {
            this.updateAttribute(true);
        } else {
            this.updateAttribute(false, !this.currentVariant.available);
        }
        this.updateVariantStatuses();
    }
    
    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateVariantStatuses();
      
        if (!this.currentVariant) {
            this.updateAttribute(true);
            this.updateStickyAddToCart(true);
        } else {
            this.updateMedia(200);
            if (!document.querySelector('.featured-product')) {
    this.updateURL();
}

this.updateVariantInput();

this.renderProductAjaxInfo();

this.renderProductInfo();

this.updateAttribute(
    false,
    !this.currentVariant.available
);

this.updateStickyAddToCart(
    false,
    !this.currentVariant.available
);

this.checkQuantityWhenVariantChange();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
  
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }
    
    updateMasterId() {

    this.decodeOptions();

    const options = this.options;
    const variants = this.getVariantData();

    let matchedVariant = null;

    /*
     * Check each variant without creating temporary
     * arrays with map() + includes().
     *
     * The old version created a new array for every
     * variant on every tap.
     */
    for (let i = 0; i < variants.length; i++) {

        const variant = variants[i];
        const variantOptions = variant.options;

        if (!variantOptions || variantOptions.length !== options.length) {
            continue;
        }

        let matches = true;

        for (let j = 0; j < options.length; j++) {

            if (options[j] !== variantOptions[j]) {
                matches = false;
                break;
            }
        }

        if (matches) {
            matchedVariant = variant;
            break;
        }
    }

    this.currentVariant = matchedVariant;
}      

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        
        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;
        window.setTimeout(() => {
            $(newMedia).trigger('click');
        }, time);

        if (!this.isFullWidth || window.innerWidth < 768) return;

        const mediaToReplace = document.querySelector('.productView-image[data-index="1"]')
        const imageToReplace = mediaToReplace.querySelector('img')

        if (!this.currentVariant) return;

        const image = this.currentVariant?.featured_image;

        if (image == null) return;

        imageToReplace.setAttribute('src',  image.src)
        imageToReplace.setAttribute('srcset', image.src)
        imageToReplace.setAttribute('alt', image.alt)

        if (mediaToReplace.getBoundingClientRect().top < window.scrollY) {
            this.scrollToBlock(mediaToReplace)
        }
    }

    scrollToBlock(block) {
        const headerHeight = document.querySelectorAll('.section-header-navigation')[0]?.getBoundingClientRect().height 
        const announcementBarHeight = document.querySelectorAll('.announcement-bar')[0]?.getBoundingClientRect().height 
        const positionTop = block.getBoundingClientRect().top - headerHeight - announcementBarHeight 

        window.scrollTo({
            top: positionTop,
            behavior: 'smooth'
        })
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {

    if (!this.currentVariant?.id) {
        return;
    }

    const variantId = String(this.currentVariant.id);

    const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.product},
         #product-form-installment-${this.dataset.product}`
    );

    productForms.forEach((productForm) => {

        const input =
            productForm.querySelector('input[name="id"]');

        if (!input) {
            return;
        }

        /*
         * Don't dispatch a change event when the value
         * is already the selected variant.
         */
        if (String(input.value) === variantId) {
            return;
        }

        input.value = variantId;

        input.dispatchEvent(
            new Event('change', {
                bubbles: true
            })
        );
    });
}

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {

    const productId = this.dataset.product;
    const variantId = this.currentVariant?.id;

    if (!variantId) return;

    const priceId = `product-price-${productId}`;
    const propertyId = `product-property-${productId}`;
    const descriptionSelector =
        `[data-product-description-${productId}]`;

    fetch(
        `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`
    )
        .then((response) => response.text())
        .then((responseText) => {

            const html =
                new DOMParser().parseFromString(
                    responseText,
                    'text/html'
                );

            /*
             * =================================================
             * PRICE
             * =================================================
             */

            const destination =
                document.getElementById(priceId);

            const source =
                html.getElementById(priceId);

            if (source && destination) {

                destination.innerHTML =
                    source.innerHTML;

                /*
                 * Convert ONLY the product price.
                 * Do NOT scan the whole document.
                 */
                if (this.checkNeedToConvertCurrency()) {

                    const currencyCode =
                        document
                            .getElementById('currencies')
                            ?.querySelector('.active')
                            ?.getAttribute('data-currency');

                    if (currencyCode) {

                        Currency.convertAll(
                            window.shop_currency,
                            currencyCode,
                            `#${priceId} span.money`,
                            'money_format'
                        );
                    }
                }
            }


            /*
             * =================================================
             * PRODUCT PROPERTY
             * =================================================
             */

            const destinationProperty =
                document.getElementById(propertyId);

            const sourceProperty =
                html.getElementById(propertyId);

            if (destinationProperty) {

                if (sourceProperty) {

                    destinationProperty.innerHTML =
                        sourceProperty.innerHTML;

                    destinationProperty.style.display =
                        'table';

                } else {

                    destinationProperty.style.display =
                        'none';
                }

            } else if (sourceProperty) {

                const product =
                    document.querySelector(
                        '.productView-product'
                    );

                const options =
                    document.querySelector(
                        '.productView-options'
                    );

                if (product && options) {

                    product.insertBefore(
                        sourceProperty,
                        options
                    );
                }
            }


            /*
             * =================================================
             * PRODUCT DESCRIPTION
             *
             * This used to require a SECOND AJAX request
             * through updateProductInfo().
             * =================================================
             */

            const destinationDesc =
                document.querySelector(
                    descriptionSelector
                );

            const sourceDesc =
                html.querySelector(
                    descriptionSelector
                );

            if (sourceDesc && destinationDesc) {

                destinationDesc.innerHTML =
                    sourceDesc.innerHTML;

                if (
                    destinationDesc.closest(
                        '.toggle-content--height'
                    )
                ) {
                    destinationDesc.style.maxHeight =
                        null;
                }
            }


            /*
             * =================================================
             * REVEAL PRICE
             * =================================================
             */

            if (destination) {

                destination.classList.remove(
                    'visibility-hidden'
                );
            }
        })
        .catch(() => {
            /*
             * Ignore failed variant AJAX requests.
             * Do not interrupt the customer's interaction.
             */
        });
}

    renderProductInfo() {
        if(this.item.find('[data-sku]').length > 0){
            this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku);
        }

        if(this.item.find('[data-barcode]').length > 0){
            this.item.find('[data-barcode] .productView-info-value').text(this.currentVariant.barcode);
        }

        var inventory = this.currentVariant?.inventory_management;

        if(inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inventoryQuantity = parseInt(inven_num);

                this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);

                if(this.item.find('[data-inventory]').length > 0){
                    if(inventoryQuantity > 0){
                        const showStock = this.item.find('[data-inventory]').data('stock-level');
                        if (showStock == 'show') {
                            this.item.find('[data-inventory] .productView-info-value').text(inventoryQuantity+' '+window.inventory_text.inStock);
                        }
                        else {
                            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
                        }
                    } else {
                        this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
                    }
                }

                hotStock(inventoryQuantity);
            }
        }

        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const optionSticky = sticky.find('.select__select');

            optionSticky.val(this.currentVariant.id);
        }
    }

    updateProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const description = `[data-product-description-${this.dataset.product}]`
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destinationDesc = document.querySelector(description);
                const sourceDesc = html.querySelector(description);

                if (sourceDesc && destinationDesc) {
                    destinationDesc.innerHTML = sourceDesc.innerHTML;
                    if (destinationDesc.closest('.toggle-content--height')){
                        destinationDesc.style.maxHeight = null;
                    }
                }
        });
    }

    updateAttribute(unavailable = true, disable = true){
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        var quantityInput = this.item.find('input[name="quantity"]'),
            notifyMe = this.item.find('.productView-notifyMe'),
            hotStock = this.item.find('.productView-hotStock'),
            buttonAddtocart = this.item.find('.product-form__submit'),
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

        if (isNaN(maxValue)) {
            maxValue = maxValue = parseInt(buttonAddtocart.attr('data-inventory-quantity'));
        } else {
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
        }
        
        if(unavailable){
            var text = window.variantStrings.unavailable;

            quantityInput.attr('disabled', true);
            notifyMe.stop(true, true).hide();
            addButton.setAttribute('disabled', true);
            addButton.textContent = text;
            quantityInput.closest('quantity-input').addClass('disabled');

            if(hotStock.length > 0) hotStock.addClass('is-hiden');
        } else {
            if (disable) {
                var text = window.variantStrings.soldOut,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span');

moneySpan.className =
    'pramogh-variant-subtotal-currency';

moneySpan.style.cssText =
    'display:none!important';

moneySpan.innerText = subTotal;

document.body.appendChild(moneySpan);

if (this.checkNeedToConvertCurrency()) {

    const currencyCode =
        document
            .getElementById('currencies')
            ?.querySelector('.active')
            ?.getAttribute('data-currency');

    if (currencyCode) {

        Currency.convertAll(
            window.shop_currency,
            currencyCode,
            '.pramogh-variant-subtotal-currency',
            'money_format'
        );
    }
}

subTotal = moneySpan.innerText;

moneySpan.remove();

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }
                    } else if (window.subtotal.style == '2') {
                        text = window.subtotal.text.replace('[value]', subTotal);
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', true);
                addButton.setAttribute('disabled', true);
                addButton.textContent = text;
                quantityInput.closest('quantity-input').addClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val() || 1;
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.find('.halo-notify-product-variant').val(this.currentVariant.title);
                    notifyMe.find('.notifyMe-text').empty();
                    notifyMe.stop(true, true).show();
                }
            } else {
                var text,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span');

moneySpan.className =
    'pramogh-variant-subtotal-currency';

moneySpan.style.cssText =
    'display:none!important';

moneySpan.innerText = subTotal;

document.body.appendChild(moneySpan);

if (this.checkNeedToConvertCurrency()) {

    const currencyCode =
        document
            .getElementById('currencies')
            ?.querySelector('.active')
            ?.getAttribute('data-currency');

    if (currencyCode) {

        Currency.convertAll(
            window.shop_currency,
            currencyCode,
            '.pramogh-variant-subtotal-currency',
            'money_format'
        );
    }
}

subTotal = moneySpan.innerText;

moneySpan.remove();

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }

                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.variantStrings.addToCart;
                        }
                    } else if (window.subtotal.style == '2') {
                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.subtotal.text.replace('[value]', subTotal);
                        }
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', false);
                addButton.removeAttribute('disabled');
                addButton.textContent = text;
                quantityInput.closest('quantity-input').removeClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');
                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val() || 1;
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
    notifyMe.stop(true, true).hide();
}
            }
        }
    }

    updateStickyAddToCart(unavailable = true, disable = true){

    const sticky = this.item.find('.productView-stickyCart');

    /*
     * Sticky cart doesn't exist on every product/page state.
     * Stop immediately instead of doing any more DOM work.
     */
    if (!sticky.length) {
        return;
    }

    const itemImage = sticky.find('.sticky-image');
    const option = sticky.find('.select__select');

    const stickyForm =
        document.getElementById(
            `product-form-sticky-${this.dataset.product}`
        );

    /*
     * Sticky form may not exist yet while the product
     * section is loading.
     */
    if (!stickyForm) {
        return;
    }

    const input =
        stickyForm.querySelector(
            'input[name="id"]'
        );

    const button =
        stickyForm.querySelector(
            '[name="add"]'
        );

    /*
     * Nothing useful can happen without these elements.
     */
    if (!input || !button) {
        return;
    }

    const quantityInput =
        this.item.find(
            'input[name="quantity"]'
        );

    const maxValue =
        parseInt(
            quantityInput.attr(
                'data-inventory-quantity'
            )
        );

    if (unavailable) {

        const text =
            window.variantStrings.unavailable;

        button.setAttribute(
            'disabled',
            true
        );

        button.textContent = text;

        return;
    }


    /*
     * No selected variant = nothing to update.
     */
    if (!this.currentVariant) {
        return;
    }


    /*
     * Update sticky product image.
     */
    const image =
        this.currentVariant.featured_image;

    if (image != null) {

        const stickyImage =
            itemImage.find('img');

        if (stickyImage.length) {

            stickyImage.attr({
                'src': image.src,
                'srcset': image.src,
                'alt': image.alt
            });
        }
    }


    /*
     * Update selected variant in sticky selector.
     */
    option.val(
        this.currentVariant.id
    );


    /*
     * Update sticky add-to-cart state.
     */
    let text;

    if (disable) {

        text =
            window.variantStrings.soldOut;

        button.setAttribute(
            'disabled',
            true
        );

    } else {

        if (
            this.currentVariant.available &&
            maxValue <= 0 &&
            this.currentVariant.inventory_management === 'shopify'
        ) {

            text =
                window.variantStrings.preOrder;

        } else {

            text =
                window.variantStrings.addToCart;
        }

        button.removeAttribute(
            'disabled'
        );
    }

    button.textContent = text;


    /*
     * Update sticky variant ID only when it
     * actually changed.
     *
     * This avoids firing an unnecessary change
     * event during the same interaction.
     */
    const variantId =
        String(this.currentVariant.id);

    if (String(input.value) !== variantId) {

        input.value =
            variantId;

        input.dispatchEvent(
            new Event(
                'change',
                {
                    bubbles: true
                }
            )
        );
    }
}

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }

    checkQuantityWhenVariantChange() {
        var quantityInput = this.closest('.productView-details').querySelector('input.quantity__input')
        var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
        var inputValue = parseInt(quantityInput?.value);

        let value = inputValue 

        if (inputValue > maxValue && maxValue > 0) {
            value = maxValue
        } else {
            value = inputValue
        }

        if (value < 1 || isNaN(value)) value = 1 
      
        if (quantityInput) {
          quantityInput.value = value
        }
      
        document.getElementById('product-add-to-cart').dataset.available = this.currentVariant.available && maxValue <= 0
    }

updateVariantStatuses() {
    const variantData = this.variantData || this.getVariantData();
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];

    if (!variantData.length || !inputWrappers.length) {
        return;
    }

    const inputLength = inputWrappers.length;

    /*
     * Read selected values ONCE.
     * Avoid repeated :checked DOM queries during the tap.
     */
    const selectedValues = inputWrappers.map((option) => {
        return option.querySelector(':checked')?.value || '';
    });

    /*
     * Keep only the variants that match the options already selected.
     *
     * This replaces repeated:
     * filter() -> map() -> filter() -> map()
     * work for every option.
     */
    let matchingVariants = variantData;

    inputWrappers.forEach((option, index) => {

        const header = option.querySelector('[data-header-option]');

        if (header && selectedValues[index]) {
            header.textContent = selectedValues[index];
        }

        /*
         * First option:
         * all variants are valid candidates.
         */
        if (index === 0) {
            if (inputLength > 1) {
                matchingVariants = variantData;
                return;
            }
        }

        /*
         * For option 2+:
         * narrow the current variant set using the
         * previously selected option.
         */
        if (index > 0) {
            const previousValue = selectedValues[index - 1];

            matchingVariants = matchingVariants.filter((variant) => {
                return variant[`option${index}`] === previousValue;
            });
        }

        const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option')
        ];

        if (!optionInputs.length) {
            return;
        }

        /*
         * Build Sets once instead of creating large arrays
         * with repeated filter/map operations.
         */
        const optionValues = new Set();
        const availableOptionValues = new Set();

        matchingVariants.forEach((variant) => {

            const value = variant[`option${index + 1}`];

            if (value != null) {
                optionValues.add(value);

                if (variant.available) {
                    availableOptionValues.add(value);
                }
            }
        });

        this.setInputAvailability(
            optionInputs,
            optionValues,
            availableOptionValues
        );
    });

    /*
     * IMPORTANT:
     * The old code called updateImageSwatch()
     * INSIDE the inputWrappers loop.
     *
     * That meant the same image-swatch calculation
     * could run 2–3 times during one tap.
     *
     * Run it ONLY ONCE.
     */
    if (inputLength > 1) {
        const selectedOptionOneVariants = variantData.filter((variant) => {
            return variant.option1 === selectedValues[0];
        });

        const variantSwatches = this.querySelectorAll(
            '.product-form__swatch'
        );

        if (variantSwatches.length > 1) {
            this.updateImageSwatch(selectedOptionOneVariants);
        }
    }
}


updateImageSwatch(selectedOptionOneVariants) {

    const inputWrapper = this.querySelectorAll(
        '.product-form__input'
    )[1];

    if (!inputWrapper) {
        return;
    }

    const imageLabels = [
        ...inputWrapper.querySelectorAll('label')
    ];

    const imageSpans = [
        ...inputWrapper.querySelectorAll('label>span.pattern')
    ];

    const imageSpanImages = [
        ...inputWrapper.querySelectorAll(
            'label>span.expand>img'
        )
    ];

    const inputList = [
        ...inputWrapper.querySelectorAll('input')
    ];

    if (!inputList.length) {
        return;
    }

    /*
     * Build a lookup table once.
     *
     * OLD:
     * Every input searched the entire variant array.
     *
     * NEW:
     * One pass through the variants,
     * then O(1) lookup for each swatch.
     */
    const imageByOption = new Map();

    selectedOptionOneVariants.forEach((variant) => {

        const optionValue = variant.option2;
        const image = variant.featured_image;

        if (
            optionValue &&
            image &&
            !imageByOption.has(optionValue)
        ) {
            imageByOption.set(optionValue, image);
        }
    });

    inputList.forEach((item, index) => {

        const image = imageByOption.get(item.value);
        const label = imageLabels[index];
        const span = imageSpans[index];
        const spanImage = imageSpanImages[index];

        if (!label) {
            return;
        }

        if (image) {

            label.style.display = 'inline-block';

            if (span) {
                span.style.backgroundImage =
                    `url("${image.src}")`;
            }

            if (spanImage) {
                spanImage.srcset = image.src;
            }

        } else {

            label.style.display = 'none';

        }
    });
}         

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                input.classList.remove('soldout');
                input.innerText = input.getAttribute('value');
            } else {
                input.classList.add('soldout');
                optionInputsValue.includes(input.getAttribute('value')) ? input.innerText = input.getAttribute('value') + ' (Sold out)' : input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'))
            }
        });
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                input.nextSibling.classList.remove('soldout', 'unavailable');
                input.nextSibling.classList.add('available');
            } else {
                input.nextSibling.classList.remove('available', 'unavailable');
                input.nextSibling.classList.add('soldout');

                if (window.variantStrings.hide_variants_unavailable && !optionInputsValue.includes(input.getAttribute('value'))) {
                    input.nextSibling.classList.add('unavailable')
                    if (!input.checked) return;
                    let inputsValue;
                    availableOptionInputsValue.length > 0 ? inputsValue = availableOptionInputsValue : inputsValue = optionInputsValue;
                    input.closest('.product-form__input').querySelector(`input[value="${inputsValue[0]}"]`).checked = true;
                    this.dispatchEvent(new Event('change'))
                }
            }
        });
    }
        
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );

        if (!this.checkHasMultipleVariants()) {
            this.initProductQuantity();
            this.checkVariantInventory();
        }
    }

    onInputChange(event) {
        event.preventDefault(); 
        var inputValue = this.input.value;
        var maxValue = parseInt(this.input.dataset.inventoryQuantity);
        var currentId = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="id"]')?.value;
        var saleOutStock  = document.getElementById('product-add-to-cart').dataset.available === 'true' || false ;
        const addButton = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="add"]');

        if(inputValue < 1) {
            inputValue = 1;

            this.input.value =  inputValue;
        }
        
        if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
            var arrayInVarName = `selling_array_${this.input.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[currentId];
          
            if(itemStatus == 'deny') {
              inputValue = maxValue
              this.input.value = inputValue;
              const message = getInputMessage(maxValue)
              showWarning(message, 3000)
            }
        } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
            this.input.value = inputValue;
        }

        if (window.subtotal.show) {

    var text,
        price = this.input.dataset.price,
        subTotal = 0;

    /*
     * Calculate subtotal directly.
     */
    subTotal = inputValue * price;

    subTotal = Shopify.formatMoney(
        subTotal,
        window.money_format
    );

    subTotal = extractContent(subTotal);

    /*
     * Create ONE temporary conversion element.
     *
     * IMPORTANT:
     * This element has its own selector so Currency.convertAll()
     * only processes this single element instead of scanning
     * every .money element on the product page.
     */
    const moneySpan = document.createElement('span');

    moneySpan.className =
        'pramogh-subtotal-currency';

    moneySpan.style.cssText =
        'display:none!important';

    moneySpan.innerText = subTotal;

    document.body.appendChild(moneySpan);

    /*
     * Convert ONLY this subtotal.
     *
     * OLD:
     * Currency.convertAll(..., 'span.money', ...)
     *
     * OLD version scanned every money element on the page.
     *
     * NEW:
     * only the temporary subtotal span is processed.
     */
    if (this.checkNeedToConvertCurrency()) {

        const currencyCode =
            document
                .getElementById('currencies')
                ?.querySelector('.active')
                ?.getAttribute('data-currency');

        if (currencyCode) {
            Currency.convertAll(
                window.shop_currency,
                currencyCode,
                '.pramogh-subtotal-currency',
                'money_format'
            );
        }
    }

    /*
     * Read converted value.
     */
    subTotal = moneySpan.innerText;

    /*
     * Remove without jQuery.
     */
    moneySpan.remove();


    /*
     * Update the visible subtotal.
     */
    if (window.subtotal.style == '1') {

        const pdView_subTotal =
            document.querySelector('.productView-subtotal .money') ||
            document.querySelector('.productView-subtotal .money-subtotal');

        if (pdView_subTotal) {
            pdView_subTotal.textContent = subTotal;
        }

    } else if (window.subtotal.style == '2') {

        text = window.subtotal.text.replace(
            '[value]',
            subTotal
        );

        if (addButton) {
            addButton.textContent = text;
        }
    }

            const stickyCart = document.querySelector(
    '[data-sticky-add-to-cart]'
);

if (stickyCart) {

    /*
     * Move sticky-cart DOM writes out of the main
     * quantity-input handler.
     *
     * This lets the browser finish the tap interaction
     * before updating the secondary sticky UI.
     */
    requestAnimationFrame(() => {

        const stickyPrice = stickyCart.querySelector(
            '.money-subtotal .money'
        );

        if (stickyPrice) {
            stickyPrice.textContent = subTotal;
        }

        if (window.subtotal.show) {

            const stickyComparePrice =
                stickyCart.querySelector(
                    '.money-compare-price .money'
                );

            const comparePriceElement =
                stickyCart.querySelector(
                    '.money-compare-price'
                );

            if (
                stickyComparePrice &&
                comparePriceElement
            ) {

                let comparePrice =
                    comparePriceElement.getAttribute(
                        'data-compare-price'
                    );

                if (comparePrice) {

                    comparePrice =
                        inputValue * Number(comparePrice);

                    comparePrice =
                        Shopify.formatMoney(
                            comparePrice,
                            window.money_format
                        );

                    comparePrice =
                        extractContent(comparePrice);

                    stickyComparePrice.textContent =
                        comparePrice;
                }
            }
        }
    });
}
        }

        if (this.classList.contains('quantity__group--2') || this.classList.contains('quantity__group--3')) {
            const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
            mainQty.value = inputValue;

            const mainQty2Exists = !!document.querySelector('.quantity__group--2 .quantity__input');
            const mainQty3Exists = !!document.querySelector('.quantity__group--3 .quantity__input');

            if (this.classList.contains('quantity__group--2') && mainQty3Exists) {
                const mainQty3 = document.querySelector('.quantity__group--3 .quantity__input');
                mainQty3.value = inputValue;
            }
            else if (this.classList.contains('quantity__group--3') && mainQty2Exists) {
                const mainQty2 = document.querySelector('.quantity__group--2 .quantity__input');
                mainQty2.value = inputValue;
            }
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    checkNeedToConvertCurrency() {
        return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
    }
    
    checkHasMultipleVariants() {
        const arrayInVarName = `product_inven_array_${this.querySelector('[data-product]').dataset.product}`
        this.inven_array = window[arrayInVarName];
        return Object.keys(this.inven_array).length > 1
    }
        
    initProductQuantity() {
        if(this.inven_array != undefined) {
            var inven_num = Object.values(this.inven_array),
                inventoryQuantity = parseInt(inven_num);

            this.querySelector('input[name="quantity"]').setAttribute('data-inventory-quantity', inventoryQuantity);
            this.querySelector('input[name="quantity"]').dataset.inventoryQuantity = inventoryQuantity
        }
    }

    checkVariantInventory() {
        const addBtn = document.getElementById('product-add-to-cart')
        this.input.disabled = addBtn.disabled 
        this.querySelector('.btn-quantity.minus').disabled = addBtn.disabled
        this.querySelector('.btn-quantity.plus').disabled = addBtn.disabled
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(document.querySelector('.product-option [type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('quantity-input', QuantityInput);

function hotStock(inventoryQuantity) {
    const productView = document.querySelector('.productView');
    const hotStock = productView.querySelector('.productView-hotStock');
    if(hotStock) {
        let hotStockText = hotStock.querySelector('.hotStock-text'),
            maxStock = parseFloat(hotStock.dataset.hotStock),
            textStock;

        if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
            hotStock.matches('.style-2') ? textStock  = window.inventory_text.hotStock2.replace('[inventory]', inventoryQuantity) : textStock  = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
            if (hotStockText) hotStockText.innerHTML = textStock;
            hotStock.classList.remove('is-hide');
        } else {
            hotStock.classList.add('is-hide');
        }

        if (hotStock.matches('.style-2')) {
            const invenProgress = inventoryQuantity / maxStock * 100,
                hotStockProgressItem = hotStock.querySelector('.hotStock-progress-item');
            if (hotStockProgressItem) hotStockProgressItem.style.width = `${invenProgress}%`;
        }
    }
}
const hotStockNoOptions = document.querySelector('.productView .productView-hotStock[data-current-inventory]');
if (hotStockNoOptions) {
    const inventoryQuantity = parseFloat(hotStockNoOptions.dataset.currentInventory);
    hotStock(inventoryQuantity);
}


function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}